module.exports = __webpack_public_path__ + "static/media/icon-menu-kutuphanem.7b95e11d.svg";